import React, { useState, useRef, useReducer, useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import { useSeatData } from "../../../store/MasterDataContext";
import { FilterDropDown} from './FilterDropDown';
import { Card } from "@material-tailwind/react";
import { defaultSeatValues } from "./DefaultSeatValues";
import { useSeatSearchContext } from "../../../store/SeatSearchContextProvider";

export function SeatsVerticalPanel() {
  const { seatMasterData } = useSeatData();
  const masterData = useMemo(() => seatMasterData, [seatMasterData]);
  console.log(masterData);

  const initialValues = useMemo(() => defaultSeatValues, [defaultSeatValues]);
  console.log(initialValues);
  const initialState = {
    academicyear: null,
    academicyears: [],
    board: null,
    boards: [],
    round: null,
    rounds: [],
    quota: null,
    quotas: [],
    category: null,
    categorys: [],
    gender: null,
    genders: [],
  };
  const [state, dispatch] = useReducer(dropdownReducer, initialState);
  const { control, handleSubmit, watch, setValue } = useForm({ defaultValues: initialValues });
  const [resettingDefaults, setResettingDefaults] = useState(true);
  const [dropdownsReady, setDropDownsReady] = useState(false);
  const { updateSeatSearchArray } = useSeatSearchContext(); // Use the context function

  

  // Watch changes to form fields
  const academicyear = watch("academicyear");
  const board = watch("board");
  const round = watch("round");
  const quota = watch("quota");
  const category = watch("category");
  const gender = watch("gender");
  
  
  const prevAcademicyearRef = useRef();
  const prevBoardRef = useRef();
  const prevRoundRef = useRef();
  const prevQuotaRef = useRef();
  const prevCategoryRef = useRef();
  const prevGenderRef = useRef();
  

  const watchFields = {
    academicyear: [prevAcademicyearRef, ["board"]],
    board: [prevBoardRef, ["round"]],
    round: [prevRoundRef, ["quota"]],
    quota: [prevQuotaRef, ["category"]],
    category: [prevCategoryRef, ["gender","common", "summary"]],
    gender: [prevGenderRef, []],
  };

  const onSubmit = (data) => {
    console.log('in submit', data);
    updateSeatSearchArray(data); // Update the seat search array with form data
  };

  const resetDefaults = () => {
    setDropDownsReady(false);
    setResettingDefaults(true);
    let dependents = [];
    Object.entries(watchFields).forEach(([fieldName, [ref, fieldDependents]]) => {
      dependents = dependents.concat(handleFieldChange(fieldName, initialValues[fieldName]?.value, ref, fieldDependents));
    });
    dispatchItems("academicyear");
    dependents.forEach((dependent) => {
      console.log("Dispatching items for", dependent);
      dispatchItems(dependent);
    });
    setResettingDefaults(false);
    setDropDownsReady(true);
  };

  function getOptions(fieldName) {
    console.log(fieldName, state[fieldName]);
    if (!state[fieldName] || state[fieldName].length === 0) {
      return [{ value: "", label: "Loading..." }]; // Or return an empty array []
    }
    let optionsArray = [];
    if (state[fieldName].length === 1 && state[fieldName][0] === null) {
      //do nothing, return empty array
    } else if (state[fieldName].length > 0) {
      optionsArray = state[fieldName].map((item) => ({
        value: item ? item : null,
        label: item ? item : "ANY",
      }));
    }
    console.log(fieldName, optionsArray);
    return optionsArray;
  }

  const handleFieldChange = (fieldName, currentValue, ref, dependents) => {
    console.log(fieldName, currentValue, ref, dependents);
    const prevValue = ref.current;
    const hasChanged = prevValue !== currentValue;
    if (currentValue && (hasChanged || resettingDefaults)) {
      setValue(fieldName, currentValue);
      ref.current = currentValue;
    }
    return dependents;
  };

  function dropdownReducer(state, action) {
    switch (action.type) {
      case "SET_ACADEMICYEARS":
        return { ...state, academicyears: action.payload };
      case "SET_ACADEMICYEAR":
        return { ...state, academicyear: action.payload, board: [] };
      case "SET_BOARDS":
        return { ...state, boards: action.payload };
      case "SET_BOARD":
        return { ...state, board: action.payload, round: [], summary: [] };
      case "SET_ROUNDS":
        return { ...state, rounds: action.payload };
      case "SET_ROUND":
        return { ...state, round: action.payload, quota: [],  };
      case "SET_QUOTAS":
        return { ...state, quotas: action.payload };
      case "SET_QUOTA":
        return { ...state, quota: action.payload, category: []};
      case "SET_CATEGORYS":
        return { ...state, categorys: action.payload };
      case "SET_CATEGORY":
        return { ...state, category: action.payload, gender: [], common: [] };
      case "SET_GENDERS":
        return { ...state, genders: action.payload };
      case "SET_GENDER":
        return { ...state, gender: action.payload };
      default:
        return state;
    }
  }

  let filterFn = () => true;

  const buildExpression = (data, fieldName, filterFn) => {
    let filterData = data.filter(filterFn);
    console.log(filterData);
    console.log(fieldName);
    let fName = fieldName;
    if (fieldName === "category") {
      fName = "caste";
    }
    let elements = [...new Set(filterData.map((item) => item[fName]))];
    console.log(elements);
    if (typeof elements === "undefined" || !Array.isArray(elements)) {
      elements = [null];
    } else if (elements.length === 1 && elements[0] === "ANY") {
      elements = [null];
    }
    return elements;
  };

  const addCondition = (currentFilter, newCondition) => {
    return (item) => currentFilter(item) && newCondition(item);
  };

  const dispatchItems = (fieldName) => {
    console.log(fieldName);
    let uniqueElements = [];
    switch (fieldName) {
      case "academicyear":
        filterFn = () => true;
        break;
      case "board":
        if (resettingDefaults) {
          filterFn = addCondition(filterFn, (item) => item["academicyear"] === initialValues.academicyear.value);
        } else {
          filterFn = addCondition(filterFn, (item) => item["academicyear"] === academicyear);
        }
        break;
      case "round":
        if (resettingDefaults) {
          filterFn = addCondition(filterFn, (item) => item["academicyear"] === initialValues.academicyear.value);
          filterFn = addCondition(filterFn, (item) => item["board"] === initialValues.board.value);
        } else {
          filterFn = addCondition(filterFn, (item) => item["academicyear"] === academicyear);
          filterFn = addCondition(filterFn, (item) => item["board"] === board);
        }
        break;
      case "quota":
        if (resettingDefaults) {
          filterFn = addCondition(filterFn, (item) => item["academicyear"] === initialValues.academicyear.value);
          filterFn = addCondition(filterFn, (item) => item["board"] === initialValues.board.value);
          filterFn = addCondition(filterFn, (item) => item["round"] === initialValues.round.value);
        } else {
          filterFn = addCondition(filterFn, (item) => item["academicyear"] === academicyear);
          filterFn = addCondition(filterFn, (item) => item["board"] === board);
          filterFn = addCondition(filterFn, (item) => item["round"] === round);
        }
        break;
      case "category":
        if (resettingDefaults) {
          filterFn = addCondition(filterFn, (item) => item["academicyear"] === initialValues.academicyear.value);
          filterFn = addCondition(filterFn, (item) => item["board"] === initialValues.board.value);
          filterFn = addCondition(filterFn, (item) => item["round"] === initialValues.round.value);
          filterFn = addCondition(filterFn, (item) => item["quota"] === initialValues.quota.value);
        } else {
          filterFn = addCondition(filterFn, (item) => item["academicyear"] === academicyear);
          filterFn = addCondition(filterFn, (item) => item["board"] === board);
          filterFn = addCondition(filterFn, (item) => item["round"] === round);
          filterFn = addCondition(filterFn, (item) => item["quota"] === quota);
        }
        break;
      case "gender":
        if (resettingDefaults) {
          filterFn = addCondition(filterFn, (item) => item["academicyear"] === initialValues.academicyear.value);
          filterFn = addCondition(filterFn, (item) => item["board"] === initialValues.board.value);
          filterFn = addCondition(filterFn, (item) => item["round"] === initialValues.round.value);
          filterFn = addCondition(filterFn, (item) => item["quota"] === initialValues.quota.value);
          filterFn = addCondition(filterFn, (item) => item["caste"] === initialValues.category.value);
        } else {
          filterFn = addCondition(filterFn, (item) => item["academicyear"] === academicyear);
          filterFn = addCondition(filterFn, (item) => item["board"] === board);
          filterFn = addCondition(filterFn, (item) => item["round"] === round);
          filterFn = addCondition(filterFn, (item) => item["quota"] === quota);
          filterFn = addCondition(filterFn, (item) => item["caste"] === category);
        }
        break;
    }
    
    uniqueElements = buildExpression(masterData, fieldName, filterFn);
    console.log(fieldName, uniqueElements);
    if (uniqueElements && uniqueElements.length > 0) {
      let dispatchOption = `SET_${fieldName.toUpperCase()}S`;
      dispatch({ type: dispatchOption, payload: uniqueElements });
      // Check if the current value is still valid
      const currentValue = watch(fieldName);
      const isValidValue = uniqueElements.some((element) => element === currentValue);
      console.log(fieldName, currentValue, isValidValue);

      // Dispatch to update the selected value only if the current value is not valid
      let valueToSet = null;
      console.log(resettingDefaults, isValidValue);
      // default to the first element if current is not valid
      if (!isValidValue) {
        let firstOptionIsNull = typeof uniqueElements[0] === undefined || uniqueElements[0] === "" || uniqueElements[0] ===null; 
        console.log(firstOptionIsNull)
        valueToSet = firstOptionIsNull ? null : uniqueElements[0];// default to the first element if current is not valid
        console.log(valueToSet)
        setValue(fieldName, valueToSet);
        let dispatchType = `SET_${fieldName.toUpperCase()}`;
        console.log(dispatchType, valueToSet);
        dispatch({ type: dispatchType, payload: valueToSet });
      }
      console.log("state after field", state);
    } else {
      setValue(fieldName, null);
      let dispatchOption = `SET_${fieldName.toUpperCase()}S`;
      dispatch({ type: dispatchOption, payload: [] });
      let dispatchType = `SET_${fieldName.toUpperCase()}`;
      dispatch({ type: dispatchType, payload: null });
    }
  };

  // Initial Default Values
  useEffect(() => {
    if (masterData && masterData.length > 0) {
      resetDefaults();
    }
  }, []);

  
  console.log("Outside useEffect - Current board value:", board);
  useEffect(() => {
    if (resettingDefaults) return;
    setDropDownsReady(false);
    if (masterData && masterData.length > 0) {
      let dependents = [];
      console.log(watchFields);
      // Iterate through each field and update if it has changed
      Object.entries(watchFields).forEach(([fieldName, [ref, fieldDependents]]) => {
        dependents = dependents.concat(
                handleFieldChange(fieldName, eval(fieldName), ref, fieldDependents));
      });
      console.log(dependents);
      dependents.forEach((dependent) => {
        console.log("Dispatching items for", dependent);
        dispatchItems(dependent);
      });
    }
    setDropDownsReady(true);
  }, [academicyear, board, round, quota, category, setValue]);

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-row h-8 ml-1 mr-1 rounded-none border-none font-bold whitespace-nowrap 
                      normal-case font-nunito items-center justify-between  bg-white">
          <button type="submit" className="flex items-start text-xs ml-1 p-0">
            <span className="text-xs text-secondary-900">Apply</span>
          </button>
          <button type="button" onClick={resetDefaults} className="flex text-primary-500 items-end mr-1 p-0">
            <span className="text-xs">Reset Defaults</span>
          </button>
        </div>
        <div>
          {console.log(dropdownsReady)}
          {dropdownsReady && (
            <Card className="mt-0 mb-2 pb-2 rounded-none border-t-2 border-primary-500 shadow-md bg-white">
              {Object.keys(state)
                .filter((key) => key.endsWith("s") && Array.isArray(state[key]) && state[key].length > 0)
                .map((key) => {
                  const singularKey = key.slice(0, -1);
                  console.log(singularKey);
                  let keyOptions = getOptions(key);
                  console.log(key, keyOptions);
                  return <FilterDropDown key={singularKey} dd_name={singularKey} dd_options={keyOptions} control={control} />;
                })}
            </Card>
          )}
        </div>
      </form>
    </div>
  );
}
